/** F606 Coach Messages page — AI-coach conversation logs. */
import { Bot } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606CoachMessagesPage() {
  return (
    <F606DataPage
      entity="coach-messages"
      titleAr="رسائل الكوتش"
      titleEn="Coach messages"
      icon={Bot}
      emptyIcon={Bot}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        { key: 'user_name', ar: 'المستخدم', en: 'User', render: (r) => r.user_name || r.sender_name || '—' },
        {
          key: 'content',
          ar: 'الرسالة', en: 'Message',
          render: (r) => (
            <div>
              <div className="text-white truncate max-w-lg">{r.content || r.message || r.text || '—'}</div>
              {r.role && (
                <span className={`inline-flex mt-0.5 px-1.5 py-0.5 rounded text-[9px] font-bold ${
                  r.role === 'assistant' || r.role === 'coach'
                    ? 'bg-sky-500/15 text-sky-300' : 'bg-white/10 text-white/60'
                }`}>{r.role}</span>
              )}
            </div>
          ),
        },
        { key: 'tokens', ar: 'الرموز', en: 'Tokens', render: (r) => r.tokens ?? r.token_count ?? '—', className: 'w-20 text-center text-[10px] font-mono text-white/60' },
        {
          key: 'created_at',
          ar: 'التاريخ', en: 'When',
          render: (r) => r.created_at ? new Date(r.created_at).toLocaleString() : '—',
          className: 'w-40 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
